import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Navbar from './Components/Navbar'
import {Login} from './Components/Login'
import {Signup} from './Components/Signup'
import Chatroom from './Components/Chatroom'

import { BrowserRouter as Router,Switch,Route} from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Navbar props={localStorage.getItem('token')}/>

      <Route exact path="/">
        <Login />
      </Route>
      <Route exact path="/login">
        <Login />
      </Route>
      <Route exact path="/Signup">
        <Signup />
      </Route>
      <Route exact path="/Chat">
        <Chatroom />
      </Route>
    </Router>
    
  </React.StrictMode>,
  document.getElementById('root')
);
